import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "styled-components";
import Theme from "../components/react-components/Styles/Theme";
import GlobalStyles from "../components/react-components/Styles/Global";
import { Container, FiltersContainer, ContentContainer } from "../components/react-components/shared-components/Ui/Grid/Grid";
import { FilterCard } from "../components/react-components/shared-components/SideFilter/FilterCard";
import { MembersProvider } from "./Context/MembersContext";
import { FilterByCategoriesCompany } from "../components/react-components/members-components/FilterByCategoriesCompany";
import { Views } from "../components/react-components/members-components/Views/Views";
import { CleanFilters } from "../components/react-components/members-components/CleanFilters";
import { SearchBar } from "../components/react-components/members-components/SearchBar";
import { ViewToggler } from "../components/react-components/members-components/Views/ViewToggler";
import { InfoBar } from "../components/react-components/members-components/InfoBar";
import { Pagination } from "../components/react-components/members-components/Pagination";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import i18n from "../i18n/i18n";
import { PageLoading } from "../components/react-components/shared-components/Loading/PageLoading";
export var Members = function () {
    React.useEffect(function () {
        var _a;
        // @ts-ignore
        var langCode = ((_a = document.getElementById("language-code")) === null || _a === void 0 ? void 0 : _a.value) || "en";
        if ((langCode === null || langCode === void 0 ? void 0 : langCode.length) === 2) {
            i18next.changeLanguage(langCode);
        }
    }, []);
    return (_jsx(Suspense, { fallback: _jsx(PageLoading, {}), children: _jsx(I18nextProvider, { i18n: i18n, children: _jsx(MembersProvider, { children: _jsxs(ThemeProvider, { theme: Theme, children: [_jsx(GlobalStyles, {}), _jsxs(Container, { children: [_jsxs(FiltersContainer, { children: [_jsx(SearchBar, {}), _jsxs(FilterCard, { children: [_jsx(CleanFilters, {}), _jsx(FilterByCategoriesCompany, {})] })] }), _jsxs(ContentContainer, { children: [_jsx(ViewToggler, {}), _jsx(InfoBar, {}), _jsx(Views, {}), _jsx(Pagination, {})] })] })] }) }) }) }));
};
var domNode = document.querySelector("#members");
if (domNode) {
    var root = createRoot(domNode);
    root.render(_jsx(Members, {}));
}
